import { styled, component, spin } from '../../utils/style';
import { Format } from '../../utils/styles-constants';
import { DriveItemListDisplayType } from './constants';
const InfiniteScroll = require('react-infinite-scroller');

export const DriveItemListContainer = styled()(component.div, 'DriveItemListContainer')`
	position: relative;
	flex-grow: 1;
`;

const StyledDriveItemList = styled()(component.div, 'StyledDriveItemList')`
	position: absolute;
	right: 0;
	left: 0;
	top: 0;
	bottom: 0;
	overflow-x: auto;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	padding: 9px;
	padding-top: 0;

	@media ${Format.SmartphonePortrait} {
		padding: 0;
	}
`;

export const ListStatus = styled()(component.h2, 'ListStatus') `
	padding-left: 9px;
`;

export const LoadingStatus = styled()(component.div, 'LoadingStatus') `
	margin: 10px 9px;
	font-size: 21px;
	font-weight: bold;
	display: flex;
	align-items: center;

	& > svg {
		height: 35px;
		width: 35px;
		animation: ${spin} 2s linear infinite;
		margin-right: 20px;
	}
`;

export const DriveItemListVariants: ({}) = {
	[DriveItemListDisplayType.Grid]: StyledDriveItemList.extend``,
	[DriveItemListDisplayType.Row]: StyledDriveItemList.extend`
		@media ${Format.Smartphone} {
			padding: 0;
		}
	`,
	[DriveItemListDisplayType.Masonry]: StyledDriveItemList.extend``,
};

const StyledInfiniteScroll = styled()(component(InfiniteScroll), 'StyledInfiniteScroll')`
	transform: translate3d(0,0,0);
`;

export const StyledInfiniteScrollVariants: ({}) = {
	[DriveItemListDisplayType.Grid]: StyledInfiniteScroll.extend`
		display: flex;
		flex-flow: row wrap;
		margin: -4.5px;

		@media ${Format.SmartphonePortrait} {
			margin: -4.5px 0;
		}
	`,
	[DriveItemListDisplayType.Row]: StyledInfiniteScroll.extend`
		display: flex;
		flex-flow: row wrap;
		margin: -4.5px;

		@media ${Format.Smartphone} {
			margin: 0;
		}

	`,
	[DriveItemListDisplayType.Masonry]: StyledInfiniteScroll.extend`
		margin: -4.5px;

		@media ${Format.SmartphonePortrait} {
			margin: -4.5px 0;
		}
	`,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/styles.ts